/* ==========================================================================
   Millstore Wishlist — wishlist nativa del tema (senza app esterna)
   --------------------------------------------------------------------------
   - Ospiti: salvataggio in localStorage.
   - Clienti loggati (opzionale): sincronizzazione su metafield cliente via
     Customer Account API (OAuth PKCE + discovery endpoint).
   - Liste multiple, salva-per-dopo, condivisione via link.
   ========================================================================== */
(function () {
  'use strict';

  var LS_WL = 'millstore.wishlist.v1';
  var LS_SFL = 'millstore.saveforlater.v1';
  var LS_TOKEN = 'millstore.wishlist.token';
  var LS_PKCE = 'millstore.wishlist.pkce';
  var LS_STATE = 'millstore.wishlist.state';

  var cfg = (window.MillstoreWishlist && window.MillstoreWishlist.config) || {};
  var API_VERSION = cfg.apiVersion || '2026-07';

  /* ------------------------------------------------------------------ *
   *  Storage helpers
   * ------------------------------------------------------------------ */
  function readJSON(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function writeJSON(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { /* localStorage pieno o bloccato */ }
  }
  function hasLocalStorage() {
    try {
      var t = '__wltest__';
      localStorage.setItem(t, '1');
      localStorage.removeItem(t);
      return true;
    } catch (e) {
      return false;
    }
  }

  /* ------------------------------------------------------------------ *
   *  Stato wishlist
   * ------------------------------------------------------------------ */
  var state = { lists: [], updatedAt: 0 };

  function ensureDefaultList() {
    if (!state.lists.length) {
      state.lists.push({ id: uid(), name: 'Preferiti', items: [] });
    }
  }

  function uid() {
    return 'l' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  function loadState() {
    var saved = readJSON(LS_WL);
    if (saved && Array.isArray(saved.lists)) {
      state = saved;
    }
    ensureDefaultList();
  }

  function persistState() {
    state.updatedAt = Date.now();
    writeJSON(LS_WL, state);
    updateCounts();
    if (sync.enabled() && cfg.customerLoggedIn) {
      sync.push();
    }
  }

  /* ------------------------------------------------------------------ *
   *  API pubblica
   * ------------------------------------------------------------------ */
  function getLists() {
    return state.lists;
  }

  function getList(id) {
    for (var i = 0; i < state.lists.length; i++) {
      if (state.lists[i].id === id) return state.lists[i];
    }
    return state.lists[0] || null;
  }

  function isSaved(productId) {
    for (var i = 0; i < state.lists.length; i++) {
      if (state.lists[i].items.some(function (it) { return String(it.productId) === String(productId); })) {
        return true;
      }
    }
    return false;
  }

  function toggleItem(data, listId) {
    listId = listId || (state.lists[0] && state.lists[0].id);
    var list = getList(listId);
    if (!list) return { added: false };
    var idx = list.items.findIndex(function (it) { return String(it.productId) === String(data.productId); });
    if (idx > -1) {
      list.items.splice(idx, 1);
      persistState();
      return { added: false };
    }
    list.items.push({
      productId: String(data.productId),
      variantId: String(data.variantId || data.productId),
      handle: data.handle || '',
      title: data.title || '',
      image: data.image || '',
      price: data.price != null ? data.price : null,
      compareAtPrice: data.compareAtPrice != null ? data.compareAtPrice : null,
      url: data.url || '',
      available: data.available !== 'false' && data.available !== false,
      addedAt: Date.now()
    });
    persistState();
    return { added: true };
  }

  function removeItem(listId, productId) {
    var list = getList(listId);
    if (!list) return;
    list.items = list.items.filter(function (it) { return String(it.productId) !== String(productId); });
    persistState();
  }

  function createList(name) {
    var list = { id: uid(), name: (name || 'Nuova lista').trim() || 'Nuova lista', items: [] };
    state.lists.push(list);
    persistState();
    return list;
  }

  function renameList(listId, name) {
    var list = getList(listId);
    if (!list || !name) return;
    list.name = String(name).trim() || list.name;
    persistState();
  }

  function deleteList(listId) {
    if (state.lists.length <= 1) return; // mantieni almeno una lista
    state.lists = state.lists.filter(function (l) { return l.id !== listId; });
    persistState();
  }

  function moveToList(fromListId, toListId, productId) {
    var from = getList(fromListId);
    var to = getList(toListId);
    if (!from || !to || from.id === to.id) return;
    var item = from.items.find(function (it) { return String(it.productId) === String(productId); });
    if (!item) return;
    from.items = from.items.filter(function (it) { return String(it.productId) !== String(productId); });
    to.items.push(item);
    persistState();
  }

  function totalCount() {
    var n = 0;
    state.lists.forEach(function (l) { n += l.items.length; });
    return n;
  }

  // Unisce la lista locale (es. salvata da ospite) con quella remota dell'account,
  // deduplicando per productId e accorpando le liste con lo stesso nome.
  function mergeLists(localState, remoteState) {
    var merged = { lists: [], updatedAt: Date.now() };
    (remoteState.lists || []).forEach(function (rl) {
      merged.lists.push({ id: rl.id, name: rl.name, items: (rl.items || []).slice() });
    });
    (localState.lists || []).forEach(function (ll) {
      var target = null;
      for (var i = 0; i < merged.lists.length; i++) {
        var sameName = ll.name && merged.lists[i].name && ll.name.trim().toLowerCase() === merged.lists[i].name.trim().toLowerCase();
        if (sameName || ll.id === merged.lists[i].id) { target = merged.lists[i]; break; }
      }
      if (!target) {
        merged.lists.push({ id: ll.id, name: ll.name, items: (ll.items || []).slice() });
        return;
      }
      (ll.items || []).forEach(function (item) {
        if (!target.items.some(function (t) { return String(t.productId) === String(item.productId); })) {
          target.items.push(item);
        }
      });
    });
    return merged;
  }

  /* ------------------------------------------------------------------ *
   *  Salva per dopo
   * ------------------------------------------------------------------ */
  function getSavedForLater() {
    var arr = readJSON(LS_SFL);
    return Array.isArray(arr) ? arr : [];
  }

  function saveForLaterAdd(data) {
    var arr = getSavedForLater();
    if (!arr.some(function (it) { return String(it.productId) === String(data.productId); })) {
      arr.push({
        productId: String(data.productId),
        variantId: String(data.variantId || data.productId),
        handle: data.handle || '',
        title: data.title || '',
        image: data.image || '',
        price: data.price != null ? data.price : null,
        url: data.url || '',
        available: true,
        addedAt: Date.now()
      });
      writeJSON(LS_SFL, arr);
    }
    updateCounts();
  }

  function saveForLaterRemove(productId) {
    var arr = getSavedForLater().filter(function (it) { return String(it.productId) !== String(productId); });
    writeJSON(LS_SFL, arr);
    updateCounts();
  }

  /* ------------------------------------------------------------------ *
   *  Contatori header
   * ------------------------------------------------------------------ */
  function updateCounts() {
    var n = totalCount();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* ------------------------------------------------------------------ *
   *  Pulsanti (prodotto / collezione / header)
   * ------------------------------------------------------------------ */
  function isInList(listId, productId) {
    var list = getList(listId);
    return !!list && list.items.some(function (it) { return String(it.productId) === String(productId); });
  }

  function buttonData(btn) {
    return {
      productId: btn.getAttribute('data-wishlist-product-id') || btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-wishlist-variant-id') || btn.getAttribute('data-variant-id'),
      handle: btn.getAttribute('data-wishlist-handle'),
      title: btn.getAttribute('data-wishlist-title'),
      image: btn.getAttribute('data-wishlist-image'),
      price: btn.getAttribute('data-wishlist-price'),
      compareAtPrice: btn.getAttribute('data-wishlist-compare-at'),
      url: btn.getAttribute('data-wishlist-url'),
      available: btn.getAttribute('data-wishlist-available')
    };
  }

  function targetListId(btn) {
    return btn.getAttribute('data-wishlist-list') || (state.lists[0] && state.lists[0].id);
  }

  function getPopover(btn) {
    var wrapper = btn.closest ? btn.closest('.wishlist-control') : null;
    return wrapper ? wrapper.querySelector('[data-wishlist-list-popover]') : null;
  }

  function bindButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = '1';

      var data = buttonData(btn);
      var productId = data.productId;

      refreshButton(btn, getPopover(btn) ? isSaved(productId) : isInList(targetListId(btn), productId));

      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var popover = getPopover(btn);
        if (popover) {
          // Con selettore di lista: il click apre il menu (non aggiunge subito).
          var wasHidden = popover.hidden;
          closeAllPopovers();
          if (wasHidden) {
            renderListPopover(popover);
            popover.hidden = false;
          }
          return;
        }
        var listId = targetListId(btn);
        var res = toggleItem(data, listId);
        refreshButton(btn, isInList(listId, productId));
        notify(res.added ? 'Aggiunto alla lista desideri' : 'Rimosso dalla lista desideri', btn);
      });
    });
  }

  function renderListPopover(popover) {
    var wrapper = popover.closest ? popover.closest('.wishlist-control') : null;
    var btn = wrapper ? wrapper.querySelector('[data-wishlist-toggle]') : null;
    var productId = btn ? btn.getAttribute('data-wishlist-product-id') : null;
    var html = '<ul>';
    state.lists.forEach(function (l) {
      var check = isInList(l.id, productId)
        ? '<span class="wishlist-option__check is-checked">✓</span>'
        : '<span class="wishlist-option__check"></span>';
      html += '<li><button type="button" class="wishlist-list-option" data-wl-list-option data-list-id="' + esc(l.id) + '">' + check + '<span>' + esc(l.name) + '</span></button></li>';
    });
    html += '<li class="wishlist-list-popover__divider" role="separator"></li>';
    html += '<li><button type="button" class="wishlist-list-option wishlist-list-option--new" data-wl-list-option data-list-id="__new__">＋ Nuova lista…</button></li>';
    html += '</ul>';
    popover.innerHTML = html;
  }

  function bindPopovers(root) {
    (root || document).querySelectorAll('[data-wishlist-list-popover]').forEach(function (popover) {
      if (popover.dataset.popoverBound) return;
      popover.dataset.popoverBound = '1';
      renderListPopover(popover);
      popover.addEventListener('click', function (ev) {
        var option = ev.target && ev.target.closest ? ev.target.closest('[data-wl-list-option]') : null;
        if (!option) return;
        var listId = option.getAttribute('data-list-id');
        var wrapper = popover.closest('.wishlist-control');
        var btn = wrapper ? wrapper.querySelector('[data-wishlist-toggle]') : null;
        if (!btn) return;
        var productId = btn.getAttribute('data-wishlist-product-id');

        if (listId === '__new__') {
          var name = window.prompt('Nome della nuova lista:');
          if (name && name.trim()) {
            createList(name);
            notify('Lista creata: ' + state.lists[state.lists.length - 1].name, btn);
          }
          popover.hidden = true;
          return;
        }

        var res = toggleItem(buttonData(btn), listId);
        refreshButton(btn, isSaved(productId));
        notify(res.added ? 'Aggiunto alla lista desideri' : 'Rimosso dalla lista desideri', btn);
        popover.hidden = true;
      });
    });
  }

  function closeAllPopovers() {
    document.querySelectorAll('[data-wishlist-list-popover]').forEach(function (p) { p.hidden = true; });
  }

  // Pulsante manuale "Sincronizza la lista" (pagina wishlist, clienti loggati)
  function bindSyncUI() {
    var btn = document.getElementById('wishlist-sync-btn');
    if (!btn) return;
    var status = document.getElementById('wishlist-sync-status');
    function refresh() {
      if (sync.token()) {
        btn.textContent = 'Sincronizza di nuovo';
        if (status) status.textContent = '✓ Lista sincronizzata sul tuo account';
      } else {
        btn.textContent = 'Sincronizza la lista';
        if (status) status.textContent = '';
      }
    }
    refresh();
    btn.addEventListener('click', function () {
      if (sync.token()) {
        sync.pull().then(refresh);
      } else {
        sync.login();
      }
    });
  }

  function refreshButton(btn, saved) {
    btn.classList.toggle('is-active', !!saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.querySelector('[data-wishlist-label]');
    if (label) {
      label.textContent = saved ? (btn.getAttribute('data-wishlist-label-added') || 'Nella lista') : (btn.getAttribute('data-wishlist-label') || 'Aggiungi ai preferiti');
    }
  }

  function notify(msg, anchor) {
    var el = document.createElement('div');
    el.className = 'wishlist-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 1800);
  }

  /* ------------------------------------------------------------------ *
   *  Salva per dopo (dal carrello)
   * ------------------------------------------------------------------ */
  function bindSaveForLater(root) {
    (root || document).querySelectorAll('[data-save-for-later]').forEach(function (btn) {
      if (btn.dataset.sflBound) return;
      btn.dataset.sflBound = '1';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        var data = {
          productId: btn.getAttribute('data-product-id'),
          variantId: variantId,
          handle: btn.getAttribute('data-handle'),
          title: btn.getAttribute('data-title'),
          image: btn.getAttribute('data-image'),
          price: btn.getAttribute('data-price'),
          url: btn.getAttribute('data-url')
        };
        saveForLaterAdd(data);
        // rimuovi dal carrello (qty 0), preferendo l'indice di riga se presente
        var line = btn.getAttribute('data-line');
        var qs = line
          ? 'line=' + encodeURIComponent(line) + '&quantity=0'
          : 'id=' + encodeURIComponent(variantId) + '&quantity=0';
        fetch(cfg.routes.cartChange + (cfg.routes.cartChange.indexOf('?') > -1 ? '&' : '?') + qs, { method: 'POST' })
          .then(function (r) {
            if (r.ok) { window.location.reload(); }
            else { notify('Impossibile aggiornare il carrello', btn); }
          })
          .catch(function () { notify('Impossibile aggiornare il carrello', btn); });
      });
    });
  }

  /* ------------------------------------------------------------------ *
   *  Pagina wishlist (rendering)
   * ------------------------------------------------------------------ */
  function renderPage() {
    var root = document.getElementById('millstore-wishlist');
    if (!root) return;
    root.innerHTML = pageHTML();
    bindPageEvents(root);
  }

  function pageHTML() {
    var lists = state.lists;
    var sfl = getSavedForLater();

    var listsHTML = lists.map(function (list) {
      return '' +
        '<section class="wishlist-list" data-list-id="' + list.id + '">' +
          '<header class="wishlist-list__head">' +
            '<h2 class="wishlist-list__title"><span class="wishlist-list__name" data-wl-name>' + esc(list.name) + '</span> ' +
            '<span class="wishlist-list__count">(' + list.items.length + ')</span></h2>' +
            '<div class="wishlist-list__actions">' +
              '<button type="button" class="wishlist-btn--text" data-wl-share>Condividi</button>' +
              '<button type="button" class="wishlist-btn--text" data-wl-rename>Rinomina</button>' +
              (lists.length > 1 ? '<button type="button" class="wishlist-btn--text wishlist-btn--danger" data-wl-delete>Elimina</button>' : '') +
            '</div>' +
          '</header>' +
          (list.items.length ? itemRows(list) : '<p class="wishlist-empty">Questa lista è vuota.</p>') +
        '</section>';
    }).join('');

    var sflHTML = '' +
      '<section class="wishlist-list wishlist-list--sfl">' +
        '<header class="wishlist-list__head"><h2 class="wishlist-list__title">Salva per dopo</h2></header>' +
        (sfl.length ? itemRowsSFL(sfl) : '<p class="wishlist-empty">Nessun articolo salvato per dopo.</p>') +
      '</section>';

    var addForm = '' +
      '<form class="wishlist-new" data-wl-new>' +
        '<input type="text" placeholder="Nome nuova lista" required maxlength="60">' +
        '<button type="submit" class="btn btn--primary">Crea lista</button>' +
      '</form>';

    return '<div class="wishlist-page">' + listsHTML + addForm + sflHTML + '</div>';
  }

  function itemRows(list) {
    return list.items.map(function (it) {
      return itemRow(it, list.id, true);
    }).join('');
  }

  function itemRowsSFL(items) {
    return items.map(function (it) {
      return itemRow(it, null, false);
    }).join('');
  }

  function itemRow(it, listId, isWishlist) {
    var price = it.price != null ? formatMoney(it.price) : '';
    var img = it.image ? '<img src="' + esc(resolveImage(it.image)) + '" alt="' + esc(it.title) + '" loading="lazy">' : '';
    var actions;
    if (isWishlist) {
      actions =
        '<button type="button" class="btn btn--primary btn--sm" data-wl-add data-variant-id="' + esc(it.variantId) + '">Aggiungi al carrello</button>' +
        '<button type="button" class="wishlist-btn--text" data-wl-move>Sposta…</button>' +
        '<button type="button" class="wishlist-btn--text wishlist-btn--danger" data-wl-remove>Rimuovi</button>';
    } else {
      actions =
        '<button type="button" class="btn btn--primary btn--sm" data-wl-add data-variant-id="' + esc(it.variantId) + '">Sposta nel carrello</button>' +
        '<button type="button" class="wishlist-btn--text wishlist-btn--danger" data-wl-remove-sfl>Rimuovi</button>';
    }
    return '' +
      '<article class="wishlist-item" data-product-id="' + esc(it.productId) + '" data-variant-id="' + esc(it.variantId) + '">' +
        '<a class="wishlist-item__media" href="' + esc(it.url || '#') + '">' + img + '</a>' +
        '<div class="wishlist-item__info">' +
          '<a class="wishlist-item__title" href="' + esc(it.url || '#') + '">' + esc(it.title) + '</a>' +
          (price ? '<div class="wishlist-item__price">' + price + '</div>' : '') +
        '</div>' +
        '<div class="wishlist-item__actions">' + actions + '</div>' +
      '</article>';
  }

  function bindPageEvents(root) {
    root.querySelectorAll('[data-wl-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wishlist-item');
        var list = btn.closest('.wishlist-list');
        removeItem(list.getAttribute('data-list-id'), item.getAttribute('data-product-id'));
        renderPage();
      });
    });

    root.querySelectorAll('[data-wl-remove-sfl]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        saveForLaterRemove(btn.closest('.wishlist-item').getAttribute('data-product-id'));
        renderPage();
      });
    });

    root.querySelectorAll('[data-wl-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        btn.disabled = true;
        fetch(cfg.routes.cartAdd + (cfg.routes.cartAdd.indexOf('?') > -1 ? '&' : '?') + 'id=' + encodeURIComponent(variantId) + '&quantity=1', {
          method: 'POST',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = (cfg.routes && cfg.routes.cart) || '/cart'; })
          .catch(function () { btn.disabled = false; notify('Errore: riprova', btn); });
      });
    });

    root.querySelectorAll('[data-wl-rename]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.closest('.wishlist-list');
        var el = list.querySelector('[data-wl-name]');
        var name = window.prompt('Nuovo nome lista:', el.textContent.trim());
        if (name) {
          renameList(list.getAttribute('data-list-id'), name);
          renderPage();
        }
      });
    });

    root.querySelectorAll('[data-wl-delete]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.closest('.wishlist-list');
        if (window.confirm('Eliminare questa lista?')) {
          deleteList(list.getAttribute('data-list-id'));
          renderPage();
        }
      });
    });

    root.querySelectorAll('[data-wl-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.closest('.wishlist-list');
        shareList(list.getAttribute('data-list-id'));
      });
    });

    root.querySelectorAll('[data-wl-move]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wishlist-item');
        var list = btn.closest('.wishlist-list');
        var targetId = chooseList(list.getAttribute('data-list-id'));
        if (targetId) {
          moveToList(list.getAttribute('data-list-id'), targetId, item.getAttribute('data-product-id'));
          renderPage();
        }
      });
    });

    var form = root.querySelector('[data-wl-new]');
    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var input = form.querySelector('input');
        createList(input.value);
        input.value = '';
        renderPage();
      });
    }
  }

  function chooseList(excludeId) {
    var names = state.lists.filter(function (l) { return l.id !== excludeId; });
    if (!names.length) return null;
    var res = window.prompt('Sposta in lista:\n' + names.map(function (l, i) { return (i + 1) + ') ' + l.name; }).join('\n') + '\nInserisci il numero:');
    var idx = parseInt(res, 10) - 1;
    return names[idx] ? names[idx].id : null;
  }

  function shareList(listId) {
    var list = getList(listId);
    if (!list || !list.items.length) { notify('La lista è vuota', null); return; }
    var payload = btoa(unescape(encodeURIComponent(JSON.stringify({ n: list.name, i: list.items.map(function (it) { return { p: it.productId, v: it.variantId, h: it.handle }; }) }))));
    var url = location.origin + cfg.wishlistPageUrl + '?wl=' + payload;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { notify('Link copiato negli appunti', null); });
    } else {
      window.prompt('Copia il link:', url);
    }
  }

  async function checkImport() {
    var q = new URLSearchParams(location.search).get('wl');
    if (!q) return;
    try {
      var data = JSON.parse(decodeURIComponent(escape(atob(q))));
      if (data && Array.isArray(data.i) && data.i.length) {
        var list = createList(data.n || 'Lista condivisa');
        list.items = await Promise.all(data.i.map(async function (x) {
          var item = { productId: x.p, variantId: x.v || x.p, handle: x.h || '', title: '', image: '', price: null, url: '', available: true, addedAt: Date.now() };
          if (x.h) {
            try {
              var r = await fetch('/products/' + encodeURIComponent(x.h) + '.js', { headers: { 'Accept': 'application/json' } });
              var p = await r.json();
              item.title = p.title || '';
              item.image = p.featured_image || '';
              item.price = p.price != null ? Math.round(Number(p.price) * 100) : null;
              item.url = p.url || '';
              item.available = p.available !== false;
              if (!x.v && p.variants && p.variants[0]) item.variantId = String(p.variants[0].id);
            } catch (e) { /* mantieni dati minimi */ }
          }
          return item;
        }));
        persistState();
        if (document.getElementById('millstore-wishlist')) renderPage();
        notify('Lista importata: ' + list.name, null);
        history.replaceState(null, '', location.pathname);
      }
    } catch (e) { /* payload non valido */ }
  }

  /* ------------------------------------------------------------------ *
   *  Formattazione
   * ------------------------------------------------------------------ */
  function formatMoney(cents) {
    try {
      return (Number(cents) / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return '€' + (Number(cents) / 100).toFixed(2).replace('.', ',');
    }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function resolveImage(url) {
    if (!url) return '';
    var u = String(url);
    if (/^https?:\/\//i.test(u) || /^\/\//.test(u) || u.charAt(0) === '/') return u;
    // percorso relativo (es. 'files/...jpg') -> CDN dello store
    return '//' + location.host + '/cdn/shop/' + u.replace(/^\/+/, '');
  }

  /* ------------------------------------------------------------------ *
   *  Sincronizzazione cliente (Customer Account API)
   * ------------------------------------------------------------------ */
  var sync = {
    _endpoints: null,

    enabled: function () {
      return !!(cfg.syncEnabled && cfg.clientId && cfg.redirectUri);
    },

    discover: async function () {
      if (this._endpoints) return this._endpoints;
      try {
        var cfgRes = await fetch('/.well-known/customer-account-api', { headers: { 'Accept': 'application/json' } });
        var api = await cfgRes.json();
        var oidcRes = await fetch('/.well-known/openid-configuration', { headers: { 'Accept': 'application/json' } });
        var oidc = await oidcRes.json();
        this._endpoints = {
          graphql: findUrl(api, 'graphql'),
          authorization: oidc.authorization_endpoint,
          token: oidc.token_endpoint,
          logout: oidc.end_session_endpoint || oidc.logout_endpoint
        };
        return this._endpoints;
      } catch (e) {
        return null;
      }
    },

    token: function () { return localStorage.getItem(LS_TOKEN); },
    setToken: function (t) { if (t) localStorage.setItem(LS_TOKEN, t); else localStorage.removeItem(LS_TOKEN); },

    async login() {
      try {
        var ep = await this.discover();
        if (!ep) { notify('Sincronizzazione non disponibile', null); return false; }
        var verifier = randomString(64);
        var challenge = await pkceChallenge(verifier);
        localStorage.setItem(LS_PKCE, verifier);
        var state = randomString(16);
        localStorage.setItem(LS_STATE, state);
        var params = new URLSearchParams({
          scope: 'openid email customer-account-api:full',
          client_id: cfg.clientId,
          response_type: 'code',
          redirect_uri: cfg.redirectUri,
          state: state,
          code_challenge: challenge,
          code_challenge_method: 'S256'
        });
        location.href = ep.authorization + '?' + params.toString();
        return true;
      } catch (e) {
        notify('Errore di sincronizzazione: ' + (e && e.message ? e.message : e), null);
        return false;
      }
    },

    async handleCallback() {
      var q = new URLSearchParams(location.search);
      var code = q.get('code');
      var state = q.get('state');
      if (!code) return false;
      if (state && localStorage.getItem(LS_STATE) !== state) return false;
      var ep = await this.discover();
      var verifier = localStorage.getItem(LS_PKCE);
      if (!ep || !verifier) return false;
      try {
        var res = await fetch(ep.token, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: cfg.clientId,
            code: code,
            redirect_uri: cfg.redirectUri,
            code_verifier: verifier
          }).toString()
        });
        var data = await res.json();
        if (data.access_token) {
          this.setToken(data.access_token);
          localStorage.removeItem(LS_PKCE);
          localStorage.removeItem(LS_STATE);
          history.replaceState(null, '', location.pathname);
          await this.pull();
          return true;
        }
      } catch (e) { /* ignora */ }
      return false;
    },

    gql: async function (query, variables) {
      var ep = await this.discover();
      if (!ep || !ep.graphql) throw new Error('endpoint non disponibile');
      var token = this.token();
      if (!token) throw new Error('nessun token');
      var res = await fetch(ep.graphql, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify({ query: query, variables: variables || {} })
      });
      var json = await res.json();
      if (json.errors && json.errors.length) throw new Error(json.errors[0].message);
      return json.data;
    },

    async push() {
      if (!this.token()) return;
      try {
        var me = await this.gql('{ customer { id } }');
        var gid = me.customer && me.customer.id;
        if (!gid) return;
        await this.gql(
          'mutation($m: [MetafieldsSetInput!]!) { metafieldsSet(metafields: $m) { userErrors { field message } } }',
          {
            m: [{
              ownerId: gid,
              namespace: cfg.metafieldNamespace,
              key: cfg.metafieldKey,
              type: 'json',
              value: JSON.stringify(state)
            }]
          }
        );
      } catch (e) { /* silenzioso: resta solo locale */ }
    },

    async pull() {
      if (!this.token()) return;
      try {
        var data = await this.gql(
          'query($ns: String!, $k: String!) { customer { metafield(namespace: $ns, key: $k) { value } } }',
          { ns: cfg.metafieldNamespace, k: cfg.metafieldKey }
        );
        var value = data.customer && data.customer.metafield && data.customer.metafield.value;
        if (value) {
          var remote = JSON.parse(value);
          if (remote && Array.isArray(remote.lists)) {
            // Unisce gli elementi locali (ospite) con quelli remoti dell'account
            // invece di sovrascriverli, poi salva e ri-sincronizza.
            state = mergeLists(state, remote);
            ensureDefaultList();
            persistState();
            if (document.getElementById('millstore-wishlist')) renderPage();
          }
        } else {
          // Nessun dato remoto: al primo login salva la lista locale nell'account.
          persistState();
        }
      } catch (e) { /* silenzioso */ }
    }
  };

  /* PKCE helpers */
  function findUrl(obj, needle) {
    // Cerca ricorsivamente il primo valore stringa che contenga `needle` (es. 'graphql').
    if (typeof obj === 'string') return obj.indexOf(needle) > -1 ? obj : null;
    if (Array.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) { var v = findUrl(obj[i], needle); if (v) return v; }
      return null;
    }
    if (obj && typeof obj === 'object') {
      for (var k in obj) { var w = findUrl(obj[k], needle); if (w) return w; }
    }
    return null;
  }
  function randomString(len) {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    var arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    var out = '';
    for (var i = 0; i < len; i++) out += chars[arr[i] % chars.length];
    return out;
  }
  async function pkceChallenge(verifier) {
    var buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buf)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  /* ------------------------------------------------------------------ *
   *  Inizializzazione
   * ------------------------------------------------------------------ */
  function init() {
    if (!hasLocalStorage()) return;
    loadState();

    // callback OAuth?
    if (new URLSearchParams(location.search).get('code')) {
      sync.handleCallback().then(function (ok) { if (!ok) location.reload(); });
      return;
    }

    bindButtons();
    bindPopovers();
    bindSaveForLater();
    updateCounts();
    renderPage();
    checkImport();
    bindSyncUI();

    // Chiudi i popover della lista quando si clicca fuori.
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest || !ev.target.closest('.wishlist-control')) closeAllPopovers();
    });

    // Se il sync è attivo e il cliente è loggato con token già presente,
    // carica silenziosamente la versione remota. Il primo collegamento
    // avviene tramite il pulsante "Sincronizza la lista" (bindSyncUI).
    if (sync.enabled() && cfg.customerLoggedIn && sync.token()) {
      sync.pull();
    }

    // Osserva le variazioni del DOM (drawer, sezioni dinamiche)
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        var added = false;
        muts.forEach(function (m) {
          m.addedNodes && m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) { bindButtons(n); bindPopovers(n); bindSaveForLater(n); added = true; }
          });
        });
        if (added) updateCounts();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  // API esposte per eventuali chiamate esterne (es. pulsante sincronizza)
  window.MillstoreWishlist.syncLogin = function () { return sync.login(); };
  window.MillstoreWishlist.syncPull = function () { return sync.pull(); };
  window.MillstoreWishlist.syncHasToken = function () { return !!sync.token(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
